import StreamingPerformance from "./StreamingPerformance";

export default StreamingPerformance;
